<template>
  <div class="bg-f8f8f8 pt-20 mob-hidden relative">
    <div class="absolute bg-design2 mob-hidden main-auto">
      <img src="@/views/admin/layouts/image/Polygon 9.svg" alt="bg-polygon" />
    </div>

    <div class="px-8 pt-8">
      <div class="md:flex">
        <div
          class="md:w-1/5 zindex-1 w-full h-83vh cust-overflow-y-primary-color-grey bg-white rounded-lg"
        >
          <div class="w-full">
            <div
              class="cardbody-p rounded-t-lg bg-purple py-4 px-3 sticky z-10 top-0 w-full"
            >
              <div
                class="flex items-center cursor-pointer"
                v-for="(item, index) in plan"
                :key="'item-' + index"
                @click="handleClick('volunteer-table')"
              >
                <div
                  class="rounded-full flex justify-center bg-white items-center"
                >
                  <feather-icon
                    :icon="item.planicon"
                    class="cursor-pointer p-3 icon-size-left"
                  ></feather-icon>
                </div>

                <div class="ml-4">
                  <p class="font-semibold text-base text-white">
                    {{ item.planname }}
                  </p>
                  <!-- <base-button
                    filled
                    type="success"
                    class="flex py-0-5 px-2 mt-1"
                  >
                     @click="addBanner" 
                    <feather-icon
                      icon="UploadIcon"
                      class="mr-1 h-18w-18"
                    ></feather-icon
                    ><a class="buttontext">Upgrade</a>
                  </base-button> -->
                </div>
              </div>
            </div>

            <div
              class="rounded-full p-3 flex bg-white items-center justify-between"
            >
              <div
                class="flex cursor-pointer items-center"
                @click="showVolunteer"
              >
                <b-icon
                  icon="person-circle"
                  style="width: 35px; height: 35px; fill: #4f0a4b"
                ></b-icon>

                <h2 class="ml-2">
                  <b>{{ user.firstname + " " + user.lastname }}</b>
                </h2>
              </div>
              <div class="h2 mb-0">
                <b-icon
                  class="cursor-pointer"
                  @click="editClick"
                  icon="pencil-fill"
                ></b-icon>
              </div>
            </div>
            <div class="">
              <b-card class="cardbody-pl p-2 border-0" no-body>
                <div
                  class="flex items-center cursor-pointer hover:bg-gray-50 py-1 px-1 mt-3 rounded-lg"
                  v-for="(item, index) in menuOption"
                  :key="'item-' + index"
                  @click="handleClick('v-setting')"
                >
                  <b-icon
                    icon="gear-fill"
                    style="width: 35px; height: 35px; fill: #4f0a4b"
                    aria-hidden="true"
                  ></b-icon>

                  <div class="ml-2">
                    <p class="font-semibold text-base">
                      {{ item.textB }}
                    </p>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </div>

        <div class="md:w-4/5 w-full md:pl-3">
          <router-view></router-view>
        </div>
      </div>
      <div class="absolute bg-design8">
        <img
          src="../../../assets/images/dots.svg"
          alt="bg-polygon"
          class="h-full w-full mt-30px"
        />
      </div>

      <div class="absolute bg-design3">
        <img
          src="@/views/admin/layouts/image/Polygon 9.svg"
          alt="bg-polygon"
          class="h-150px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Slidercards from "../pages/add-volunteer/components/Slidercards.vue";
import Volunteertable from "../pages/add-volunteer/components/Volunteertable.vue";
import SessionComp from "../pages/add-volunteer/components/SessionComp.vue";
import Earningtable from "../pages/add-volunteer/components/Earningtable.vue";
import {
  BIcon,
  BIconPersonCircle,
  BIconPencilFill,
  BIconGearFill,
} from "bootstrap-vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      menus: [
        {
          icon: "ChevronRightIcon",
          text: "Dashboard",
          route: "admin-home",
        },
        {
          icon: "ChevronRightIcon",
          text: "Product",
          route: "admin-addproduct",
        },
        {
          icon: "ChevronRightIcon",
          text: "Banner",
          route: "admin-addbanner",
        },
        {
          icon: "ChevronRightIcon",
          text: "Tags",
          route: "admin-addtags",
        },
        {
          icon: "ChevronRightIcon",
          text: "Category",
          route: "admin-addcategory",
        },
        {
          icon: "ChevronRightIcon",
          text: "Sub-category",
          route: "e-commerce-admin-addsubcategory",
        },
        {
          icon: "ChevronRightIcon",
          text: "Page",
          route: "admin-page",
        },
        {
          icon: "ChevronRightIcon",
          text: "Menu",
          route: "admin-menu",
        },
        {
          icon: "ChevronRightIcon",
          text: "Taxes",
          route: "admin-taxes",
        },
        {
          icon: "ChevronRightIcon",
          text: "Customer Management",
          route: "customer-management",
        },
        {
          icon: "ChevronRightIcon",
          text: "Order Management",
          route: "order-management",
        },
        {
          icon: "ChevronRightIcon",
          text: "Sales Report",
          route: "admin-reports",
        },
        // {
        //   icon: "GithubIcon",
        //   text: "Suscriber Plan",
        //   route: "admin-subscriberplan"
        // },
        {
          icon: "ChevronRightIcon",
          text: "Analytics Dashboard",
          route: "admin-analytics",
        },

        {
          icon: "ChevronRightIcon",
          text: "Integrations",
          route: "integrations",
        },
        {
          icon: "ChevronRightIcon",
          text: "Contact Us",
          route: "contact-us",
        },
        {
          icon: "ChevronRightIcon",
          text: "Logo",
          route: "logo",
        },
        {
          icon: "BookIcon",
          text: "Coupon Management",
          route: "e-commerce-admin-couponmanagement",
        },
        // ,
        // {
        //   icon: "PhoneIcon",
        //   text: "Contact Us",
        //   route: "contact-us"
        // }
      ],
      plan: [
        {
          planname: "Partner Dashboard",
          planicon: "StarIcon",
          route: "volunteer-table",
        },
      ],
      menuOption: [
        {
          iconB: "UsersIcon",
          textB: "Set Availability",
          route: "v-setting",
        },
      ],
    };
  },
  components: {
    Slidercards,
    Volunteertable,
    SessionComp,
    Earningtable,
    BIcon,
    BIconPersonCircle,
    BIconPencilFill,
    BIconGearFill,
  },
  computed: {
    ...mapState("auth", { user: "user" }),
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    showVolunteer() {
      this.$router.push({ name: "add-volunteer" });
    },
    editClick() {
      this.$router.push({ name: "add-edit" });
    },
    async getVolunteer() {
      await this.$store.dispatch("respitecare/get_volunteerbyuserid", {
        volunteerId: this.user._id,
      });
    },
  },
  async mounted() {
    this.showVolunteer();
    await this.getVolunteer();
  },
};
</script>

<style>
.main-auto {
  margin-left: -3rem;
  width: 250px;
  overflow: hidden;
}
.h-250px {
  height: 250px;
}
.mt-30px {
  margin-top: 30px;
}
.h-150px {
  height: 150px;
}
.zindex-1 {
  z-index: 1;
}
.bg-f8f9fa {
  background: #f8f9fa;
}
.fsize25px {
  font-size: 25px;
}
.buttontext {
  font-size: 10px !important;
}
.py-0-5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
</style>
